module.exports = __webpack_public_path__ + "static/media/review_insight.d9134668.png";